export default __webpack_public_path__ + "static/media/background.5abcb4a5.jpg";